import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventCategory, GaTrackingEventName, GATrackingEventType } from '../../constants';
import { ApplicationSearchEventSource } from '~shared/modules/application-event/constants';

export class GATrackingRemoveFilterPLPsEvent implements GATrackingEvent {

  constructor(
    private filterRemoveSource: ApplicationSearchEventSource,
    private filterName: string,
    private eventType: GATrackingEventType,

  ) {
  }

  getEventType(): GATrackingEventType {
    return this.eventType;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.RemoveSearchFiltered,
      category: GaTrackingEventCategory.Category,
      label: this.getLabel()
    };
  }

  private getLabel(): string {
    switch (this.filterRemoveSource) {
      case ApplicationSearchEventSource.FilterUnselected:
        return `Filter section - ${this.filterName}`;
      case ApplicationSearchEventSource.FilterRemove:
        return `Filter tag - ${this.filterName}`;
      case ApplicationSearchEventSource.FilterRemoveAll:
        return `remove all`;
      default:
        return `remove-filter - ${this.filterName}`;
    }
  }
}
